var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompliteSquare2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "#5FC56D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.953 42.762L41.9902 53.1918C42.4181 53.5341 43.0418 53.4683 43.3888 53.0441L67.6196 23.4287",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0024 43.2553L49.4471 24.3784C49.9717 23.7373 49.8772 22.7922 49.2361 22.2676C48.5949 21.743 47.6499 21.8375 47.1253 22.4787L31.6976 41.3347L34.0024 43.2553ZM30.8361 47.1253L28.5313 45.2046L23.1787 51.7467L13.2814 44.3238C12.6187 43.8268 11.6785 43.9611 11.1814 44.6238C10.6844 45.2866 10.8187 46.2268 11.4814 46.7238L21.7621 54.4343C22.8339 55.2381 24.3487 55.0543 25.197 54.0174L30.8361 47.1253Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliteSquare2);
export default __webpack_public_path__ + "static/media/Complite-Square-2.1ec527823467e40930e2d44b7aa63eb4.svg";
export { ForwardRef as ReactComponent };